import "./styles.css";
import type { ReactNode } from "react";
import { Switch } from "@mui/material";

interface InputGroupsProps {
    icon?: string;
    title: string;
    header?: boolean;
    toggle?: {
        checked: boolean;
        onChange: (checked: boolean) => void;
    };
    addButton?: {
        label: string;
        onClick: () => void;
    };
    children: ReactNode;
    disabled?: boolean;
}

const switchSx = {
    width: 34,
    height: 21,
    padding: 0,
    "& .MuiSwitch-switchBase": {
        padding: 0,
        margin: "2.5px",
        transitionDuration: "200ms",
        "&.Mui-checked": {
            transform: "translateX(13px)",
            color: "var(--color-white)",
            "& + .MuiSwitch-track": {
                backgroundColor: "var(--color-orange)",
                opacity: 1,
                border: 0,
            },
        },
    },
    "& .MuiSwitch-thumb": {
        width: 16,
        height: 16,
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.2)",
    },
    "& .MuiSwitch-track": {
        borderRadius: "var(--radius-full)",
        backgroundColor: "var(--color-gray-01)",
        opacity: 1,
    },
};

export default function InputGroups({ icon, title, header = true, toggle, addButton, children, disabled }: InputGroupsProps) {
    return (
        <div className={`input-groups${disabled ? " input-groups--disabled" : ""}`}>
            {header && (
                <div className="input-groups-header">
                    {icon && (
                        <div className="input-groups-icon">
                            <img src={icon} alt="" width={17} height={17} />
                        </div>
                    )}
                    <span className="input-groups-title">{title}</span>
                    {toggle && <Switch checked={toggle.checked} onChange={(e) => toggle.onChange(e.target.checked)} sx={switchSx} />}
                    {addButton && (
                        <button type="button" className="input-groups-add" onClick={addButton.onClick}>
                            <img src="/icons/plus-icon.svg" alt="" width={12} height={12} />
                            <span>{addButton.label}</span>
                        </button>
                    )}
                </div>
            )}
            <div className="input-groups-content">{children}</div>
        </div>
    );
}
